export const environment = {
  production: true,
  applicationName: 'PPLApps',
  applicationVersion: '1.0.0',
  PplAppsApi: 'https://api.pplapps.co.za',
  APlusCanvasser: 'https://aplus.pplapps.co.za',
  DocUpload: 'https://docupload.pplapps.co.za',
  MDLAPP: 'https://canvasser.foneyam.co.za',
  CapfinLeads: 'https://leads.pplapps.co.za',
  MyPerformance: 'https://myperformance.pplapps.co.za',
};

